import { ICartEntry, IItem, IItemOptionModifier, IWithPricingProps } from '@rbi-ctg/menu';
import { MenuObjectTypes } from 'enums/menu';
import { IMenuItem } from 'state/menu/types';
import { IWithVendorConfig } from 'utils/vendor-config';

export interface IItemOptionModifierIsAvailable extends IWithPricingProps {
  item: IItem;
  itemOptionModifier: IItemOptionModifier;
}

export interface IItemOptionModifierPluIsAvailable extends IWithPricingProps {
  item: IItem | ICartEntry;
  itemOptionModifier: IItemOptionModifier | ICartEntry;
}

interface IMenuComboWithDaypart {
  _type: MenuObjectTypes.COMBO;
  mainItem?: IMenuItemWithDaypart | null;
  options?: Array<{
    option?: IMenuItemWithDaypart | null;
  }> | null;
}

interface IMenuItemWithDaypart {
  _type: MenuObjectTypes.ITEM;
  operationalItem?: IMenuItem['operationalItem'];
}

interface IMenuPickerWithDaypart {
  _type: MenuObjectTypes.PICKER;
  options?: Array<{
    option?: IMenuObjectWithDaypart;
  }> | null;
}

interface IMenuSectionWithDaypart {
  _type: MenuObjectTypes.SECTION;
  daypart?: Array<string | null> | null;
}

export type IMenuObjectWithDaypart =
  | IMenuComboWithDaypart
  | IMenuItemWithDaypart
  | IMenuPickerWithDaypart
  | IMenuSectionWithDaypart;

export type IAvailabilityObject = IMenuObjectWithDaypart & IWithVendorConfig;
